// move all constants to here in some time

export const UPDATE_KIDS_NAME = "UPDATE_KIDS_NAME";
export const UPDATE_ORG_ID_FOR_ACCESS_CARD = "UPDATE_ORG_ID_FOR_ACCESS_CARD";

export const POST_EVENT_ORDER_META_UPDATE_REQ = "POST_EVENT_ORDER_META_UPDATE_REQ";
export const POST_EVENT_ORDER_META_UPDATE_SUCCESS = "POST_EVENT_ORDER_META_UPDATE_SUCCESS";
export const POST_EVENT_ORDER_META_UPDATE_FAILURE = "POST_EVENT_ORDER_META_UPDATE_FAILURE";

export const GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_REQ =
  "GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_REQ";
export const GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_SUCCESS =
  "GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_SUCCESS";
export const GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_FAILURE =
  "GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_FAILURE";

export const GET_PRODUCTS_DATA_FOR_EVENT_REQ =
  "GET_PRODUCTS_DATA_FOR_EVENT_REQ";
export const GET_PRODUCTS_DATA_FOR_EVENT_SUCCESS =
  "GET_PRODUCTS_DATA_FOR_EVENT_SUCCESS";
export const GET_PRODUCTS_DATA_FOR_EVENT_FAILURE =
  "GET_PRODUCTS_DATA_FOR_EVENT_FAILURE";

export const SET_CURRENT_ACCESS_CARD_STATE = "SET_CURRENT_ACCESS_CARD_STATE";
export const CLEAR_PRODUCTS = "CLEAR_PRODUCTS";

export const GET_CUSTOMER_OFFERS_REQ = "GET_CUSTOMER_OFFERS_REQ";
export const GET_CUSTOMER_OFFERS_SUCCESS = "GET_CUSTOMER_OFFERS_SUCCESS";
export const GET_CUSTOMER_OFFERS_FAILURE = "GET_CUSTOMER_OFFERS_FAILURE";

export const GET_ADDRESS_DATA_REQ = "GET_ADDRESS_DATA_REQ";
export const GET_ADDRESS_DATA_SUCCESS = "GET_ADDRESS_DATA_SUCCESS";
export const GET_ADDRESS_DATA_FAILURE = "GET_ADDRESS_DATA_FAILURE";

export const POST_NEW_ADDRESS_REQ = "POST_NEW_ADDRESS_REQ";
export const POST_NEW_ADDRESS_SUCCESS = "POST_NEW_ADDRESS_SUCCESS";
export const POST_NEW_ADDRESS_FAILURE = "POST_NEW_ADDRESS_FAILURE";

export const PO_INIT_REQ = "PO_INIT_REQ";
export const PO_INIT_SUCCESS = "PO_INIT_SUCCESS";
export const PO_INIT_FAILURE = "PO_INIT_FAILURE";

export const UPDATE_CHECKOUT_STEPS_DATA = "UPDATE_CHECKOUT_STEPS_DATA";
export const UPDATE_SELECTED_CUSTOMER_ADDRESS = "UPDATE_SELECTED_CUSTOMER_ADDRESS";

export const CLEAR_EXISTING_PO = "CLEAR_EXISTING_PO";

export const UPDATE_BILLING_ADDRESS_FLAG = "UPDATE_BILLING_ADDRESS_FLAG";

export const FETCH_PAYBOX_DATA = "FETCH_PAYBOX_DATA";

export const FETCH_PAYBOX_DATA_SUCCESS = "FETCH_PAYBOX_DATA_SUCCESS";

export const FETCH_PAYBOX_DATA_FAILURE = "FETCH_PAYBOX_DATA_FAILURE";

export const CHOOSE_OFFER_TO_APPLY = "CHOOSE_OFFER_TO_APPLY";
export const REMOVE_OFFER_TO_APPLY = "REMOVE_OFFER_TO_APPLY";
export const APPLY_OFFER_TO_CART_REQ = "APPLY_OFFER_TO_CART_REQ";
export const APPLY_OFFER_TO_CART_SUCCESS = "APPLY_OFFER_TO_CART_SUCCESS";
export const APPLY_OFFER_TO_CART_FAILURE = "APPLY_OFFER_TO_CART_FAILURE";

export const GET_PAYMENT_RESULT = "GET_PAYMENT_RESULT";
export const GET_PAYMENT_RESULT_SUCCESS = "GET_PAYMENT_RESULT_SUCCESS";
export const GET_PAYMENT_RESULT_FAILURE = "GET_PAYMENT_RESULT_FAILURE";

export const GET_CUSTOMER_PURCHASE_ORDERS_REQ = "GET_CUSTOMER_PURCHASE_ORDERS_REQ";
export const GET_CUSTOMER_PURCHASE_ORDERS_SUCCESS = "GET_CUSTOMER_PURCHASE_ORDERS_SUCCESS";
export const GET_CUSTOMER_PURCHASE_ORDERS_FAILURE = "GET_CUSTOMER_PURCHASE_ORDERS_FAILURE";

export const UPDATE_FLAG_SHOW_HIDE_CART_ITEM_UPDATE = "UPDATE_FLAG_SHOW_HIDE_CART_ITEM_UPDATE";

export const DOWNLOAD_HD_IN_ORDER = "DOWNLOAD_HD_IN_ORDER";
export const DOWNLOAD_HD_IN_ORDER_SUCCESS = "DOWNLOAD_HD_IN_ORDER_SUCCESS";
export const DOWNLOAD_HD_IN_ORDER_FAILURE = "DOWNLOAD_HD_IN_ORDER_FAILURE";

export const SET_CHECKOUT_REFFERER = "SET_CHECKOUT_REFFERER";
export const CLEAR_CHECKOUT_REFFERER = "CLEAR_CHECKOUT_REFFERER";

export const SET_CASH_PAYMENT_DETAILS = "SET_CASH_PAYMENT_DETAILS";
export const CLEAR_CART = "CLEAR_CART";
export const CLEAR_KIDS_NAMES = "CLEAR_KIDS_NAMES";

export const SET_RESET_PASSWORD_DATA = "SET_RESET_PASSWORD_DATA";

export const GET_OTP_FOR_ACCESS_CARD = "GET_OTP_FOR_ACCESS_CARD";
export const GET_OTP_FOR_ACCESS_CARD_SUCCESS = "GET_OTP_FOR_ACCESS_CARD_SUCCESS";
export const GET_OTP_FOR_ACCESS_CARD_FAILURE = "GET_OTP_FOR_ACCESS_CARD_FAILURE";

export const VERIFY_ACCESS_CARD_OTP = "VERIFY_ACCESS_CARD_OTP";
export const VERIFY_ACCESS_CARD_OTP_SUCCESS = "VERIFY_ACCESS_CARD_OTP_SUCCESS";
export const VERIFY_ACCESS_CARD_OTP_FAILURE = "VERIFY_ACCESS_CARD_OTP_FAILURE";

export const SET_OTP_VERIFIED_STATUS = "SET_OTP_VERIFIED_STATUS";

export const POST_PO_ADDRESS_REQ = "POST_PO_ADDRESS_REQ";
export const POST_PO_ADDRESS_SUCCESS = "POST_PO_ADDRESS_SUCCESS";
export const POST_PO_ADDRESS_FAILURE = "POST_PO_ADDRESS_FAILURE";

export const GET_PO_ADDRESS_REQ = "GET_PO_ADDRESS_REQ";
export const GET_PO_ADDRESS_SUCCESS = "GET_PO_ADDRESS_SUCCESS";
export const GET_PO_ADDRESS_FAILURE = "GET_PO_ADDRESS_FAILURE";

export const SET_SHIPPING_SAME_AS_BILLING = "SET_SHIPPING_SAME_AS_BILLING";